import { AccessDenied as e } from "../../errors/access-denied.mjs";
import { BadRequest as t, BadRequestWithViolations as n } from "../../errors/bad-request.mjs";
import { ConflictError as r } from "../../errors/conflict-error.mjs";
import { FailedDependency as i } from "../../errors/failed-dependency.mjs";
import { InternalError as a } from "../../errors/internal-error.mjs";
import { invalidTokenErrorMessages as o } from "../../errors/invalid-token-error.mjs";
import { LockedError as s } from "../../errors/locked-error.mjs";
import { MaintenanceError as c } from "../../errors/maintenance-error.mjs";
import { NetworkError as l } from "../../errors/network-error.mjs";
import { NotFound as u } from "../../errors/not-found.mjs";
import { PayloadTooLarge as d } from "../../errors/payload-too-large.mjs";
import { UnauthorizedResponse as f } from "../../errors/unauthorized-response.mjs";
import { UnprocessableContentError as p } from "../../errors/unprocessable-content-error.mjs";
import { AxiosError as m, isCancel as h } from "axios";
//#region src/fetch/http-base-client/get-error-mapper.ts
var g = (g, _) => {
	let v = !1, y = [], b = () => g.post("/api/user/token/regenerate"), x = (e) => {
		y.push(e);
	}, S = () => {
		y.forEach((e) => e()), y = [];
	}, C = async (e) => {
		let t = e.config;
		if (!v) {
			v = !0;
			try {
				return await b(), v = !1, S(), await g(t);
			} catch (e) {
				throw v = !1, y = [], e;
			}
		}
		return new Promise((e) => {
			x(() => {
				e(g(t));
			});
		});
	};
	return async (g) => {
		if (h(g)) throw g;
		if (g = g, g.code === m.ERR_NETWORK) throw new l();
		let v = g.response;
		if (!v) throw g;
		switch (v.status) {
			case 400: throw "errors" in v.data ? new t(v.data) : new n(v.data);
			case 401:
				if (o.includes(v.data.message)) return await C(g);
				{
					let e = v.data.redirect || v.data.location;
					if (e) throw new f(e);
					_?.error("Unauthorized response", v.data);
				}
				break;
			case 403: {
				let t = v.data?.redirect || v.data?.location;
				throw new e(t);
			}
			case 404: throw new u(u.isNotFoundResponse(v.data) ? v.data : void 0);
			case 409: throw new r(v.data);
			case 413: throw new d();
			case 422: throw new p(v.data);
			case 423: throw new s();
			case 424: throw new i(v.data.title);
			case 503: throw new c();
			case 500:
			case 502: throw new a();
		}
		throw g;
	};
};
//#endregion
export { g as getErrorMapper };
